import { render } from "./GeneralSpecsListing.vue?vue&type=template&id=2bda6f8f&ts=true"
import script from "./GeneralSpecsListing.vue?vue&type=script&lang=ts"
export * from "./GeneralSpecsListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__